<div class="wrapper" id="pageContentWrapper">
	<div class="overlay"></div>
	<router-outlet></router-outlet>
</div>
